import {svgIconWrapper} from '../svg-icon-wrapper';

import CheckCircleRegular from './check-circle-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <CheckCircleRegular {...props} />;
}
SvgComponent.iconName = 'checkCircleRegular';

export const CheckCircleRegularIcon = svgIconWrapper(SvgComponent);
